export const getFullscript = {
  BetterWellness: "Better wellness for patients. Better support for practitioners.",
  WithAFreeAccount:
    "With a free Fullscript account, practitioners unlock wholesale ordering, virtual dispensing, and features that support group consultations — all from healthcare’s most comprehensive catalog.",
  JoinThousands:
    "Join thousands of practitioners with access to the industry’s best supplements and adherence-boosting features beyond the point-of-care.",
  CreateAFreeAccount: "Create a free account",
  AlreadyOnFullscript: "<0>Already on Fullscript? <1>Log in</1></0>",
} as const;
